import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent,
} from '@softline/dynamic';
import { GeschaeftsfallListView } from './list-view/geschaeftsfall.list-view';

export const geschaeftsfallFieldOk: FieldOkConfig = {
  name: 'geschaeftsfall',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: GeschaeftsfallListView,
        sort: {
          properties: [{ property: 'bezeichnung', title: 'Bezeichnung' }],
        },
      },
    },
  ],
};

export const geschaeftsfallMultiselectFieldOk: FieldOkConfig = {
  name: 'geschaeftsfall',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkMultiselectListViewComponent,
      title: 'Auswahl',
      config: {
        component: GeschaeftsfallListView,
        sort: {
          properties: [{ property: 'bezeichnung', title: 'Bezeichnung' }],
        },
      },
    },
  ],
};

export const geschaeftsfallQueryFieldOk: FieldOkConfig = {
  name: 'geschaeftsfall',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: QueryFieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: GeschaeftsfallListView,
        sort: {
          properties: [{ property: 'bezeichnung', title: 'Bezeichnung' }],
        },
      },
    },
  ],
};
